// 教育局api
import {baseRequest} from './base'
import globalConfig from '../config/globle.config';
import Vue from 'vue'
import { reject } from 'core-js/fn/promise';
/**
 * @desc 查询教育局列表
 */
function getBureauList(params){
  //清除空白字段
  params = utils.common.checkNull(params);
  let tempUrl = '/api/pcWeb/teaBureau/'
  return baseRequest(tempUrl,'get',params);
}

/**
 * @desc 根据教育局ID获取教育局信息
 */
function getBureauById(id){
  return baseRequest(`/api/pcWeb/teaBureau/${id}`,'get');
}

/**
 * @desc 新增教育局
 */
function addBureau(params){
  return baseRequest(`/api/pcWeb/teaBureau/create`,'post',params);
}

/**
 * @desc 删除教育局
 */
function deleteBureau(id){
  return baseRequest(`/api/pcWeb/teaBureau/delete/${id}`,'get');
}

/**
 * @desc 修改教育局
 */
function updateBureau(id,params){
  //清除空白字段
  params = utils.common.checkNull(params);
  return baseRequest(`/api/pcWeb/teaBureau/update/${id}`,'post',params);
}

/**
 * @desc 下拉搜索教育局
 */
function selectSearchBureau(params){
  let tempUrl = '/api/pcWeb/teaBureau/selectSearch'
  return baseRequest(tempUrl, 'get', params);
}

/**
 * @desc 新增或更新教育局设置
 */
function updateBureauSetting(params){
  params = utils.common.checkNull(params);
  return baseRequest(`/api/pcWeb/teaBureauSetting/createOrUpdate`,'post',params);
}

/**
 * @desc 查询教育局设置
 */
function getBureauSetting(key){
  return baseRequest('/api/pcWeb/teaBureauSetting/get/'+key, 'get');
}

/**
 * @desc 根据域名查询教育局, 注意使用了localStorage缓存，如果缓存存在，则不调用接口
 */
function getBureau(){
  let bureau = Vue.ls.get('bureau');
  if (bureau) {
    return Promise.resolve(bureau)
  }
  if (!globalConfig.domainName) {
    return Promise.reject(new Error("domainName异常"))
  }

  return new Promise((resolve, reject) => {
    var r = baseRequest('/api/pcWeb/teaBureau/getBureau', 'get', {
      domainName:globalConfig.domainName,
    });
    r.then((res) => {
      console.log(res,globalConfig.domainName,'数据正常')
      if (!res.data) {
        console.log(res,'数据存在吗')
        return reject(new Error("域名不存在或异常"+globalConfig.domainName))
      }
      Vue.ls.set('bureau', res.data)
      Vue.ls.set('bureauId', res.data.id)
      resolve(res.data)
    }).catch((reason) => {
      reject(reason)
    })
  });
}

async function getBureauId() {
  let bureauId = Vue.ls.get('bureauId')
  if (bureauId) {
    return bureauId;
  }
  let bureau = await getBureau()
  Vue.ls.set('bureauId', bureau.id)
  return bureau.id
}

/**
 * @desc 下拉搜索教育局
 */
function selectBureau(params){
  let tempUrl = '/api/pcWeb/teaBureau/selectBureau'
  return baseRequest(tempUrl, 'get', params);
}

/**
 * @desc 教育局个性化设置
 */
 function setting(id,params){
  params = utils.common.checkNull(params);
  return baseRequest(`/api/pcWeb/teaBureau/setting/${id}`,'post',params);
}

function getSetting(settingKey) {
  return baseRequest(`/api/pcWeb/teaBureau/teaBureauSetting/get/${settingKey}`,'get');
}



export default {
  getBureauList: getBureauList,
  getBureauById: getBureauById,
  addBureau: addBureau,
  deleteBureau: deleteBureau,
  updateBureau: updateBureau,
  selectSearchBureau: selectSearchBureau,
  updateBureauSetting: updateBureauSetting,
  getBureauSetting: getBureauSetting,
  getBureau,
  getBureauId,
  selectBureau: selectBureau,
  setting,
  getSetting,
}